import Icon1 from 'app/assets/images/infoCollection/group/group_size_1.svg?component'
import Icon2 from 'app/assets/images/infoCollection/group/group_size_2.svg?component'
import Icon3 from 'app/assets/images/infoCollection/group/group_size_3.svg?component'

import Hotel3Star from 'app/assets/images/infoCollection/hotel/3star.svg?component'
import Hotel4Star from 'app/assets/images/infoCollection/hotel/4star.svg?component'
import Hotel5Star from 'app/assets/images/infoCollection/hotel/5star.svg?component'
import HotelBoutique from 'app/assets/images/infoCollection/hotel/boutique.svg?component'

import Adventure from 'app/assets/images/infoCollection/purposes/adventure.svg?component'
import Sightseeing from 'app/assets/images/infoCollection/purposes/sightseeing.svg?component'
import Culture from 'app/assets/images/infoCollection/purposes/culture.svg?component'
import Relaxation from 'app/assets/images/infoCollection/purposes/relaxation.svg?component'
import Food from 'app/assets/images/infoCollection/purposes/food.svg?component'
import Photography from 'app/assets/images/infoCollection/purposes/photography.svg?component'
import Wellness from 'app/assets/images/infoCollection/purposes/wellness.svg?component'
import Faith from 'app/assets/images/infoCollection/purposes/faith.svg?component'
import WomenOnly from 'app/assets/images/infoCollection/purposes/women-only.svg?component'
import Other from 'app/assets/images/infoCollection/purposes/other.svg?component'

import StreetFood from 'app/assets/images/infoCollection/dietary/street-food.svg?component'
import FineDining from 'app/assets/images/infoCollection/dietary/fine-dining.svg?component'
import Vegetarian from 'app/assets/images/infoCollection/dietary/vegetarian.svg?component'
import CookingClass from 'app/assets/images/infoCollection/dietary/cooking-class.svg?component'
import NoPreferenceForFood from 'app/assets/images/infoCollection/dietary/no-preference.svg?component'

export enum GroupSize {
  FOUR_TO_NINE = '4-9',
  SIX_TO_NINE = '6-9', // deprecated
  TEN_TO_TWELVE = '10-12',
  THIRTEEN_TO_SIXTEEN = '13-16',
  SEVENTEEN_TO_TWENTY = '17-20',
  TWENTY_ONE_PLUS = '21++',
}

export const HotelDescription = {
  '3-star hotel': 'Comfortable & convenient',
  '4-star hotel': 'Stylish, elevated comfort',
  '5-star hotel': 'Luxury at its finest',
  'Boutique hotel': 'Unique stays & local charm',
}

export const getGroupSizeIcon = (key: string) => {
  switch (key) {
    case GroupSize.FOUR_TO_NINE:
    case GroupSize.SIX_TO_NINE: // deprecated
      return Icon1
    case GroupSize.TEN_TO_TWELVE:
      return Icon2
    default:
      return Icon3
  }
}

enum HotelStars {
  THREE = '3-star hotel',
  FOUR = '4-star hotel',
  FIVE = '5-star hotel',
  BOUTIQUE = 'Boutique hotel',
}

enum Purpose {
  ADVENTURE = 'Adventure',
  SIGHTSEEING = 'Sightseeing',
  CULTURE = 'Culture',
  RELAXATION = 'Relaxation',
  FOODIE = 'Foodie',
  PHOTOGRAPHY = 'Photography',
  WELLNESS = 'Wellness',
  FAITH = 'Christian faith',
  WOMEN_ONLY = 'Women only',
  HOST_RETREAT = 'Host a retreat',
  OTHER = 'Other',
}

export const getAccommodationIcon = (key: string) => {
  switch (key) {
    case HotelStars.THREE:
      return Hotel3Star
    case HotelStars.FOUR:
      return Hotel4Star
    case HotelStars.FIVE:
      return Hotel5Star
    case HotelStars.BOUTIQUE:
      return HotelBoutique
    default:
      return Hotel3Star
  }
}

export const getPurposeIcon = (key: string) => {
  switch (key) {
    case Purpose.ADVENTURE:
      return Adventure
    case Purpose.SIGHTSEEING:
      return Sightseeing
    case Purpose.CULTURE:
      return Culture
    case Purpose.RELAXATION:
      return Relaxation
    case Purpose.FOODIE:
      return Food
    case Purpose.PHOTOGRAPHY:
      return Photography
    case Purpose.WELLNESS:
      return Wellness
    case Purpose.FAITH:
      return Faith
    case Purpose.WOMEN_ONLY:
      return WomenOnly
    case Purpose.HOST_RETREAT:
      return Other
    case Purpose.OTHER:
      return Other
    default:
      return Other
  }
}

enum DietaryPreference {
  STREET_FOOD = 'Street food',
  FINE_DINING = 'Fine dining',
  VEGETARIAN = 'Vegetarian',
  COOKING_CLASS = 'Cooking class',
  NO_PREFERENCE_FOR_FOOD = 'No preference for food',
}

export const getDietaryPreferenceIcon = (key: string) => {
  switch (key) {
    case DietaryPreference.STREET_FOOD:
      return StreetFood
    case DietaryPreference.VEGETARIAN:
      return Vegetarian
    case DietaryPreference.FINE_DINING:
      return FineDining
    case DietaryPreference.COOKING_CLASS:
      return CookingClass
    case DietaryPreference.NO_PREFERENCE_FOR_FOOD:
      return NoPreferenceForFood
    default:
      return StreetFood
  }
}
